import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { FolderDocumentsRefreshEvent } from 'src/app/models/events/folder-documents-refresh-event';

@Injectable({
    providedIn: 'root',
})
export class DocumentsSectionEventsService {
    /**
     * Emis lorsque la section doit être rechargée.
     */
    public needRefresh = new Subject<FolderDocumentsRefreshEvent>();
}
